/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type LicenseType = (typeof LicenseType)[keyof typeof LicenseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicenseType = {
  PILOT: "PILOT",
  BASIC: "BASIC",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
} as const;
